import WorldMap from '@/components/map/WorldMap';
import Legend from '@/components/map/Legend';
import Timestamp from '@/components/map/Timestamp';
import DataSkyeLogo from '@/components/map/DataSkyeLogo';

const Index = () => {
  return (
    <div className="w-screen h-screen overflow-hidden bg-background">
      <WorldMap />
      <Legend />
      <Timestamp />
      <DataSkyeLogo />
    </div>
  );
};

export default Index;
